module.exports = __webpack_public_path__ + "static/media/power.ae1e51fd.svg";